import React from 'react';

interface Attachment {
  id: number;
  name: string;
  file: string;
  file_url: string;
  description: string | null;
}

interface ProductThumbnailProps {
  attachment_urls: Attachment[] | null;
  alt: string;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  rounded?: boolean;
}

/**
 * Compact Product Thumbnail Component
 * For small image displays like lists, tables, carts
 */
const ProductThumbnail: React.FC<ProductThumbnailProps> = ({
  attachment_urls,
  alt,
  size = 'md',
  className = '',
  onClick,
  rounded = true
}) => {
  const getFirstAttachmentUrl = (): string | undefined => {
    if (!attachment_urls || !Array.isArray(attachment_urls) || attachment_urls.length === 0) {
      return undefined;
    }
    return attachment_urls[0]?.file_url || attachment_urls[0]?.file;
  };

  const sizeStyles = {
    xs: { width: '25px', height: '25px', fontSize: '0.75rem' },
    sm: { width: '35px', height: '35px', fontSize: '0.875rem' },
    md: { width: '45px', height: '45px', fontSize: '1rem' },
    lg: { width: '60px', height: '60px', fontSize: '1.25rem' }
  };

  const imageUrl = getFirstAttachmentUrl();
  const style = sizeStyles[size];

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={alt}
        className={`${rounded ? 'rounded' : ''} ${className}`}
        style={{
          ...style,
          objectFit: 'cover'
        }}
        onClick={onClick}
      />
    );
  }

  return (
    <div
      className={`bg-light ${rounded ? 'rounded' : ''} d-flex align-items-center justify-content-center ${className}`}
      style={style}
      onClick={onClick}
    >
      <i className="ri-image-line text-muted" style={{ fontSize: style.fontSize }}></i>
    </div>
  );
};

export default ProductThumbnail;